import Vue from "vue";

type VueClass<V> = (new (...args: any[]) => V & Vue) & typeof Vue;

export function Filter(): any {
  return (
    target: Vue,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ): any => {
    const Ctor = target.constructor as VueClass<Vue>;
    Ctor.filter(propertyKey, descriptor.value);
  };
}
